
define('text!templates/modules/calendar/animated-session/animation/rename/list/custom-name-list-item.html',[],function () { return '<div class="item-section"></div>\n';});

